import { Button, Modal } from "@skbkontur/react-ui";
import * as React from "react";

import { selectUserFiles, uploadToDrive } from "../../Api/Drive/DriveClient";
import { useCandyApiClient } from "../../../../../Common/CandyApiClient/CandyApiClientContext";
import { DraftIdentity } from "../../Domain/DraftIdentity";
import { nullElement } from "../../Utils/TypingUtils";
import { arrayHasAtLeastOneItem, stringifyUnknownError } from "../../../../../Common/TypingUtils";

import cn from "./FufUploader.less";

enum UploadFufState {
    Initial,
    Uploading,
    ReadyToOpen,
    UploadingError,
}

type FufUploaderHook = [() => void, React.ReactNode];

interface DraftCreatedInfo {
    gfv: string;
    fufDriveUri: string;
    draft: DraftIdentity;
    editorUrl: string;
}

export function useFufUploader(
    getOpenEditorUrl: (url: string) => string,
    onDraftCreated?: (info: DraftCreatedInfo) => void,
    getScenario?: () => string | undefined
): FufUploaderHook {
    const api = useCandyApiClient();
    const [uploadProgress, setUploadProgress] = React.useState<number>(0);
    const [uploadFufState, setUploadFufState] = React.useState<UploadFufState>(UploadFufState.Initial);
    const [uploadingError, setUploadingError] = React.useState<string>();
    const [gfv, setGfv] = React.useState<string>("");
    const [uploadedFufEditorUrl, setUploadedFufEditorUrl] = React.useState<string>();

    return [
        async () => {
            const files = await selectUserFiles(false);
            if (!arrayHasAtLeastOneItem(files)) {
                return;
            }
            setUploadFufState(UploadFufState.Uploading);
            try {
                const upl = uploadToDrive(files[0], (progress, total) => {
                    setUploadProgress(Math.round((progress / total) * 100));
                });
                await upl.initDrive;
                // @ts-ignore
                // eslint-disable-next-line no-promise-executor-return
                const result: string = await new Promise((r, j) => upl.getDriveTask().then(r, j));
                const createResult = await api.createDraftFromDrive({
                    ns: "00000000-0000-0000-0000-000000000000",
                    fufDriveUri: result,
                    scenario: getScenario?.(),
                });
                setUploadedFufEditorUrl(createResult.editorUrl);
                setUploadFufState(UploadFufState.ReadyToOpen);
                setGfv(createResult.gfv);
                onDraftCreated?.({
                    fufDriveUri: result,
                    draft: {
                        ns: createResult.ns,
                        draftId: createResult.draftId,
                    },
                    gfv: createResult.gfv,
                    editorUrl: `${createResult.editorUrl}`,
                });
            } catch (e) {
                setUploadingError(stringifyUnknownError(e));
                setUploadFufState(UploadFufState.UploadingError);
            }
        },
        uploadFufState !== UploadFufState.Initial ? (
            <Modal onClose={() => setUploadFufState(UploadFufState.Initial)}>
                <Modal.Header>Загрузка ФУФа</Modal.Header>
                <Modal.Body>
                    <div className={cn("modal-body")}>
                        {uploadFufState === UploadFufState.Uploading && <div>Загрузка: {uploadProgress}</div>}
                        {uploadFufState === UploadFufState.ReadyToOpen && (
                            <div>
                                <div>GFV: {gfv}</div>
                                <Button
                                    onClick={() => {
                                        if (uploadedFufEditorUrl != undefined) {
                                            window.open(getOpenEditorUrl(uploadedFufEditorUrl), "_blank");
                                        }
                                        setUploadFufState(UploadFufState.Initial);
                                    }}>
                                    Открыть
                                </Button>
                            </div>
                        )}
                        {uploadFufState === UploadFufState.UploadingError && (
                            <div>
                                Error:
                                <pre>{uploadingError}</pre>
                            </div>
                        )}
                    </div>
                </Modal.Body>
            </Modal>
        ) : (
            nullElement
        ),
    ];
}
